/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserNote} from '../models/UserNote';

export interface GetUserNotes$Request {
    userId: number;
}

export interface GetUserNotes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserNotesRequest = createAction<PayloadData<void, GetUserNotes$Request>>('GET_USER_NOTES__GET_USER_NOTES__REQUEST');
export const getUserNotesSuccess = createAction<PayloadData<UserNote, GetUserNotes$Request>>('GET_USER_NOTES__GET_USER_NOTES__SUCCESS');
export const getUserNotesFailure = createAction<PayloadData<Error, GetUserNotes$Request, true>>('GET_USER_NOTES__GET_USER_NOTES__FAILURE');

export const getUserNotesActions = [
    getUserNotesRequest,
    getUserNotesSuccess,
    getUserNotesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserNotes = (meta: GetUserNotes$Request, config?: GetUserNotes$Config) => {
    return {
        CALL_API: {
            types: getUserNotesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/notes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

